<template>
    <div class="page-menu">
        <el-cascader v-if="!isCollapse && isDev" v-model="selectedMenu" placeholder="试试搜索：演出列表" clearable filterable :options="menuList" :props="{ label : 'name', value : 'link', children : 'subMenuList', emitPath : false }" size="small" style="width: 100%" @change="changeMenu"></el-cascader>
        <el-menu :collapse="isCollapse" background-color="#3d3d3d" text-color="#eee" unique-opened
            :style="`width:${menuWidth}px`" :collapse-transition="false" router :default-active="setMenuActive()">
            <template v-for="item in menuList">
                <template v-if="item.subMenuList">
                    <el-submenu :index="`${item.id}`" :key="item.id">
                        <template slot="title">
                            <i :class="[item.icon]" :style="{'color': item.iconColor || ''}"></i>
                            <span slot="title">{{ item.name }}</span>
                        </template>
                        <el-menu-item v-for="subItem in item.subMenuList" :key="subItem.id" :index="`${subItem.link}`">{{
                            subItem.name }}
                        </el-menu-item>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :index="`${item.link}`" :key="item.id">
                        <i :class="[item.icon]" :style="{'color': item.iconColor || ''}"></i>
                        <span slot="title">{{ item.name }}</span>
                    </el-menu-item>
                </template>
            </template>
        </el-menu>
    </div>
</template>
<script>
export default {
    name: "pageMenu",
    props: {
        menuWidth: {
            type: Number,
            default: 0,
        },
        isCollapse: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            menusIcon: {
                工作台: "el-icon-odometer",
                用户管理: "el-icon-user",
                秀动运营管理: "el-icon-office-building",
                订单管理: "el-icon-tickets",
                平台资金管理: "el-icon-money",
                促销管理: "el-icon-present",
                众筹管理: "el-icon-set-up",
                商品管理: "el-icon-goods",
                興情管理: "el-icon-chat-line-square",
                消息推送管理: "el-icon-message",
                财务管理: "el-icon-coin",
                数据报表: "el-icon-pie-chart",
                系统管理: "el-icon-setting",
                直播管理: "el-icon-video-camera",
                其他: "el-icon-monitor",
                演出管理: "el-icon-mic",
                社区管理: "el-icon-coffee-cup",
                酒店管理: "el-icon-office-building",
                数字藏品: "el-icon-folder-opened",
                标签管理: "el-icon-collection-tag",
                系统工具: "el-icon-suitcase",
                外域数据: "el-icon-cpu",
				内容管理: "el-icon-notebook-1",
                事件管理: 'el-icon-mouse',
				短信营销: 'el-icon-mobile-phone',
				会员管理: 'el-icon-user-solid'
            },
            iconColor: [
                '#FF393F',
                '#FF8E15',
                '#46C290',
                '#44B0EE',
                '#f9a771',
                '#FCACC1',
                '#F3D623',
                '#95AB63',
                '#ACF0F2',
                '#9575CD',
                '#E30313',
                '#09DBA5',
                '#d388f3',
                '#FA6690',
                '#F8BE02',
                '#96CA2D',
                '#799AE0',
                '#AB47BC',
                '#B36712',
                '#1C76FF',
				'#FF8E15',
				'#95AB63',
            ],
            selectedMenu: '',
            isDev: process.env.VUE_APP_ENV == 'development',
        };
    },
    computed: {
        menuList() {
            let _menuList = this.$store.state.menuList || [];
			
            let _menus = [];
            _menuList.forEach((item,index) => {
                item.icon = this.menusIcon[item.name] || this.menusIcon["其他"];
                item.iconColor = this.iconColor[index];
                _menus.push(item);
            });
            return _menus;
        },
    },
    // 监听,当路由发生变化的时候执行
    watch: {
        $route() {
            this.setMenuActive();
        },
    },
    methods: {
        //设置菜单选择项
        setMenuActive() {
            // let path = "/";
            // this.menuList.forEach((menu) => {
            //     const { subMenuList } = menu;
            //     if (subMenuList && subMenuList.length > 0) {
            //         subMenuList.forEach((item) => {
            //             if (
            //                 item.link &&
            //                 this.$route.path.match(new RegExp(item.link, "g"))
            //             ) {
            //                 path = item.link;
            //             }
            //         });
            //     } else {
            //         if (
            //             menu.link &&
            //             this.$route.path.match(new RegExp(menu.link, "g"))
            //         ) {
            //             path = menu.link;
            //         }
            //     }
            // });
            const _current = this.$route.matched[this.$route.matched.length - 1];
            //console.log(_current)
            let path = ""
            if (_current.meta.activePage) {
                path = _current.meta.activePage;
            } else if (_current.parent && _current.parent.redirect && _current.parent.redirect != "noRedirect") {
                path = _current.parent.redirect;
            } else {
                path = this.$route.path;
            }
            this.selectedMenu = path;
            return path;
        },

        // 菜单选择项改变
        changeMenu(link) {
            console.log(link)
            if (link && link.length > 0) {
                this.$router.push({ path: link });
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.el-menu {
    border: 0;
    i{
        opacity: 0.6;
    }
}
.is-opened{
    i{
        opacity: 1;
    }
}
</style>